/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Promo_EyebrowInputs */

const ja_playdata_home_promo_eyebrow = /** @type {(inputs: Playdata_Home_Promo_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEW 2026 リリース`)
};

const en_playdata_home_promo_eyebrow = /** @type {(inputs: Playdata_Home_Promo_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEW 2026 RELEASE`)
};

/**
* | output |
* | --- |
* | "NEW 2026 RELEASE" |
*
* @param {Playdata_Home_Promo_EyebrowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_promo_eyebrow = /** @type {((inputs?: Playdata_Home_Promo_EyebrowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Promo_EyebrowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_promo_eyebrow(inputs)
	return en_playdata_home_promo_eyebrow(inputs)
});